import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { DashboardComponent } from './dashboard/dashboard.component';
//import { WriterComponent } from './writer/writer.component';
import { UploadService, CookieService, AuthenticationService } from './_services/index';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkTableModule } from '@angular/cdk/table';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
//import { TableComponent } from './table/table.component';
import { InjectDirective } from './_directive/inject.directive';
import { FocusDirective } from './_directive/focus.directive';
import { TooltipDirective } from './_directive/tooltip.directive';
import { AutoGrowDirective } from './_directive/auto-grow.directive';
import { MapComponent } from './map/map.component';
//import { AgmCoreModule } from '@agm/core';
import { MapOptions } from '../config/mapOptions';
import { PagebreakComponent } from './pagebreak/pagebreak.component';
import { SectionComponent } from './section/section.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { EditableComponent } from './editable/editable.component';
import { TreeTableModule } from 'primeng/treetable';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { TooltipModule} from 'primeng/tooltip';
import { HeadnavComponent } from './headnav/headnav.component';
import { CoverComponent } from './cover/cover.component';
import { ParagraphComponent } from './paragraph/paragraph.component';
import { NgSelectModule } from '@ng-select/ng-select';
//import { TreeNode } from 'primeng/api';
//import { InputTextModule } from 'primeng/inputtext';
//import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { PanelComponent } from './panel/panel.component';
import { LogoComponent } from './logo/logo.component';
//import { TestComponent } from './test/test.component';
import { TemplateComponent } from './template/template.component';
import { CalendarModule } from 'primeng/calendar';
import { FocusTrapModule } from 'primeng/focustrap';
//import { DialogModule } from 'primeng/dialog';
//import { NewtableComponent } from './newtable/newtable.component'; 
//import { DropdownModule } from 'primeng/dropdown'; // include this for dropdown support
import { FillPipe } from './fill.pipe';
import { CAMELPipe } from './camel.pipe';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReportComponent } from './report/report.component';
import { ReportInfoComponent } from './reportinfo/reportinfo.component';
//import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { CompanyComponent } from './company/company.component';
import { DataViewModule } from 'primeng/dataview';
import { ClickOutsideModule } from 'ng-click-outside';
import { ReportresourcesComponent } from './reportresources/reportresources.component';
import { NgxMaskDirective,NgxMaskPipe, provideNgxMask} from 'ngx-mask';
import { ErisOnlyComponent } from './eris-only/eris-only.component'
import { OrderListModule } from 'primeng/orderlist';
import { ColorPickerModule } from 'ngx-color-picker';
import { EditInputComponent } from './edit-input/edit-input.component';
import { CommonModule, DatePipe } from '@angular/common';
import { SafeHtmlPipe } from './safe-html.pipe'
import { PhotologComponent } from './photolog/photolog.component';
import { TemplateKComponent } from './photolog-templates/template-k/template-k.component';
import { TemplateLComponent } from './photolog-templates/template-l/template-l.component';
import { TemplateQComponent } from './photolog-templates/template-q/template-q.component';
import { TemplateRComponent } from './photolog-templates/template-r/template-r.component';
import { TemplateSComponent } from './photolog-templates/template-s/template-s.component';
import { TemplateTComponent } from './photolog-templates/template-t/template-t.component';
import { LightboxModule } from 'ngx-lightbox';
import { CompleteComponent } from './complete/complete.component';
import { CompleteRptComponent } from './complete-rpt/complete-rpt.component';
import { PdfdataComponent } from './pdfdata/pdfdata.component';
import { CompleteTempComponent } from './complete-temp/complete-temp.component';
import { PreviewComponent } from './preview/preview.component';
import { FrmComponent } from './frm/frm.component';
import { HighlighterPipe } from './highlighter.pipe';
//import { HtmlDiffer } from 'html-differ';
@NgModule({
	declarations: [
		AppComponent,
		DashboardComponent,
		//WriterComponent,
		//TableComponent,
		InjectDirective,
		FocusDirective,
		TooltipDirective,
		AutoGrowDirective,
		MapComponent,
		PagebreakComponent,
		SectionComponent,
		HeaderComponent,
		FooterComponent,
		EditableComponent,
		HeadnavComponent,
		CoverComponent,
		ParagraphComponent,
		PanelComponent,
		LogoComponent,
		//TestComponent,
		TemplateComponent,
		FillPipe,
		CAMELPipe,
		ReportComponent,
		ReportInfoComponent,
		CompanyComponent,
		ReportresourcesComponent,
		ErisOnlyComponent,
		EditInputComponent,
		SafeHtmlPipe,
		PhotologComponent,
		TemplateKComponent,
		TemplateLComponent,
		TemplateQComponent,
		TemplateRComponent,
		TemplateSComponent,
		TemplateTComponent,
		CompleteComponent,
		CompleteRptComponent,
		PdfdataComponent,
		CompleteTempComponent,
		PreviewComponent,
		FrmComponent,
  HighlighterPipe,
  	],
	imports: [
		ColorPickerModule,
		NgxMaskDirective,//NgxMaskModule.forRoot(),
		NgxMaskPipe,
		BrowserModule,
		CalendarModule,
		FocusTrapModule,
		AppRoutingModule,
		HttpClientModule,
		NgSelectModule,
		FormsModule,
		ReactiveFormsModule,
		CKEditorModule,
		CommonModule,
		BrowserAnimationsModule,
		DragDropModule,
		CdkTableModule,
		MatTableModule,
		MatSortModule,
		MatSelectModule,
		MatSlideToggleModule,
		ClickOutsideModule,
		/*AgmCoreModule.forRoot({
			apiKey: MapOptions.license,
			libraries: ['drawing', 'places', 'geometry']
		}),*/
		TreeTableModule,
		MultiSelectModule,
		TableModule,
		OverlayPanelModule,
		OrderListModule,
		DataViewModule,
		DropdownModule,
		TooltipModule,
		NgbModule,
		//GooglePlaceModule,
		LightboxModule,
	],
	providers: [
		CookieService,
		UploadService,
		AuthenticationService,
		DatePipe,
		provideNgxMask()
	],
	bootstrap: [AppComponent]
})

export class AppModule { }
